const _mapChildren = function(item){
    console.log(item);
    let array = [item];
    if(typeof item.tableName ==="undefined") {
        item.tableName = item.name;
    }
    if(typeof item.children !=="undefined") {
        item.children.forEach(child => {
            if(typeof child.depth === "undefined"){
                child.depth = 0;
            }
            child.depth++;
            child.parent = {name: item.tableName, uuid: item.uuid};
            if(typeof child.tableName === "undefined"){
                child.tableName = child.name;
            }
            child.tableName = "&nbsp;&nbsp;&nbsp;–&nbsp;" + child.tableName;
            child = _mapChildren(child);
            array = array.concat(child);
        });
    }
    return array;
}

export default  _mapChildren;
